<template>
  <el-card>
    <div v-if="isShowTable" slot="header" class="clearfix">
      <span>用户等级付费统计</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
        <el-button v-if="isShowTable" :loading="loading" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-if="isShowTable"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        width="100"
        align="center"
      />
      <el-table-column
        v-for="(item, index) in tabHeader"
        :key="index"
        :label="item"
        width="180"
        align="center"
      >
        <el-table-column
          label="付费率"
          align="center"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[index].pay_rate }}%
          </template>
        </el-table-column>
        <el-table-column
          label="ARPU"
          align="center"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[index].arpu }}
          </template>
        </el-table-column>
        <el-table-column
          label="ARPPU"
          align="center"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[index].arppu }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div ref="chartContainer" style="width: 100%; height: 400px;margin: 20px 0" />
  </el-card>
</template>

<script>
import { getPayLevelStat } from '@/api/statistics/user_remain'
import { getLastDates } from '@/utils'
import echarts from 'echarts'

export default {
  name: 'PayLevel',
  props: {
    isShowTable: {
      type: Boolean,
      default: true
    },
    echartTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabHeader: [],
      loading: false,
      tableData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: ''
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
      this.queryParams.endDate = getLastDates(1)
    }
    this.queryParams.type = 0
    this.getTables()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      this.queryParams.type = 0
      this.getTables()
    },
    exportData() {
      this.queryParams.type = 1
      this.getTables()
    },
    getTables(key = 'pay_rate') {
      this.loading = true
      getPayLevelStat(this.queryParams).then(res => {
        this.loading = false
        if (this.queryParams.type === 1) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
        }
        const data = res.data.data
        const level = res.data.maxLevel
        const date = []
        this.initHeader(level)
        this.initChart()
        this.tableData = data
        const dataView = {}
        for (const i in this.tabHeader) {
          this.option.legend.data.push(this.tabHeader[i])
          dataView[this.tabHeader[i]] = []
        }
        for (const i in data) {
          const val = data[i]
          date.push(val.date)
          for (const k in val.data) {
            if (dataView[val.data[k].level_range]) {
              dataView[val.data[k].level_range].push(val.data[k][key])
            }
          }
        }

        for (const i in dataView) {
          const temp = {
            name: i,
            data: dataView[i],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
          this.option.series.push(temp)
        }
        this.option.xAxis.data = date
        this.chart.setOption(this.option, true)
      })
    },
    initHeader(maxLevel) {
      let start = 1
      let end = 10
      const header = []
      while (start <= maxLevel) {
        header.push(`${start}-${end}`)
        start = end + 1
        end = start + 9
      }
      this.tabHeader = header
    },
    initChart() {
      const _this = this
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: this.echartTitle
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          x: 'center',
          y: 'bottom',
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          feature: {
            myTool1: {
              show: true,
              title: '付费率',
              icon: 'path://M7 10l5 5 5-5H7z', // 自定义图标（可选择路径或图片）
              onclick: function() {
                _this.getTables('pay_rate')
              }
            },
            myTool2: {
              show: true,
              title: 'arpu',
              icon: 'path://M7 10l5 5 5-5H7z', // 自定义图标（可选择路径或图片）
              onclick: function() {
                _this.getTables('arpu')
              }
            },
            myTool3: {
              show: true,
              title: 'arppu',
              icon: 'path://M7 10l5 5 5-5H7z', // 自定义图标（可选择路径或图片）
              onclick: function() {
                _this.getTables('arppu')
              }
            }
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
      this.chart.setOption(this.option)
    }
  }
}
</script>

<style scoped>

</style>
